var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"global-loader"}},[(_vm.isShown)?_c('div',{staticClass:"global-loader",class:{ 'is-booting': _vm.isLoggingIn }},[_c('mark-loader',{attrs:{"size":72}}),(_vm.shownMessage)?_c('div',{staticClass:"global-loader-message"},[_vm._v(" "+_vm._s(_vm.shownMessage)+" ")]):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }